// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2020":"69a42241","2946":"69a42241","7935":"5eea157c","9644":"2d67ad52"}[chunkId] + ".chunk.css";
};